
export type OlapEtlFileFormat = "Parquet";